import axios from "axios";
import storage from "@/modules/auth/services/auth";
import router from "@/core/router";
import userApi from "@/modules/user/services/user";

const state = () => ({
    token: null,
    user: null,
    fullUser: null,
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    },
    refreshToken: "",
    tokenExp: "",
})

const getters = {
    isAuthenticated(state){
        return state.user !== null
    },
    isGrantedAdmin(state){
       return state.fullUser.roles.includes('ROLE_ADMIN')
    },
    isGrantedManager(state){
       return state.fullUser.roles.includes('ROLE_MANAGER')
    }
}

const mutations = {
    SET_TOKEN (state, token) {
        state.token = token
    },
    SET_USER (state, user) {
        state.user = user
    },
    SET_FULL_USER (state, payload) {
        state.fullUser = payload
    },
    SET_USER_LOGOUT(state){
        state.user = null
    },
    FIRST_CONNEXION_DONE (state){
        state.fullUser.isFirstConnexion = false
    },
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    },
    SET_API_DATA_FETCH_INIT: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    }
}

const actions = {
    isAlwaysLogIn({ commit }){
        if(storage.isLoggedIn()){
            commit('SET_TOKEN', storage.getAuthToken)
            commit('SET_USER', storage.getUserInfo())
        }
    },
    async login({ commit, dispatch },user){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        let response = await axios.post('/login',user)
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
            })
        if(response.data.token) await dispatch('attempt', response.data.token)
    },
    async logout({ commit }){
        let user =  null
        await storage.logoutUser()
        commit('SET_USER_LOGOUT',user)
        router.push('/deconnexion')
    },
    async attempt({ commit, state },credentials){
        if(credentials) {
            await storage.setAuthToken(credentials)
            await storage.fetchUser({ token: credentials})
            commit('SET_TOKEN', credentials)
        }
        if(!state.token) return false
        const user = await storage.getUserInfo()
        commit('SET_USER', user.username)
        commit('SET_API_DATA_FETCH_SUCCESS')
        // Redirect vers home avec role ?
    },

    setFullUser({ commit }){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if(localStorage.getItem('user')){
            const user = localStorage.getItem('user')
            commit('SET_FULL_USER', JSON.parse(user))
            commit('SET_API_DATA_FETCH_SUCCESS')
        }
    },
    updateFullUser({ commit, state },payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        commit('SET_FULL_USER',Object.assign(state.fullUser,payload))
        commit('SET_API_DATA_FETCH_SUCCESS')
    },
    resetPassword({ commit },payload){
        payload.isFromUser = true
        userApi.resetPwd(payload)
            .then(() => {
                let user =  null
                storage.logoutUser()
                commit('SET_USER_LOGOUT',user)
                commit('SET_API_DATA_FETCH_SUCCESS')
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    updatePassword({ commit },payload){
        userApi.updatePwd(payload)
            .then(() => {
                commit('FIRST_CONNEXION_DONE')
                commit('SET_API_DATA_FETCH_SUCCESS')
                storage.logoutUser()
                router.push('/connexion')
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    resetApiFetch({ commit }){
        commit('SET_API_DATA_FETCH_INIT')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
